// extracted by mini-css-extract-plugin
export var aboutContainer = "about-module--aboutContainer--udNIX";
export var aboutIllus = "about-module--aboutIllus--HgFS0";
export var aboutInfo = "about-module--aboutInfo--X5mSi";
export var buyInfo = "about-module--buyInfo--JmVQo";
export var hours = "about-module--hours--uGMBQ";
export var hoursList = "about-module--hoursList--lbaaL";